import { render, staticRenderFns } from "./CustomerAccountTag.vue?vue&type=template&id=c4abd00e"
import script from "./CustomerAccountTag.vue?vue&type=script&lang=js"
export * from "./CustomerAccountTag.vue?vue&type=script&lang=js"
import style0 from "./CustomerAccountTag.vue?vue&type=style&index=0&id=c4abd00e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports